import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, computed, signal } from '@angular/core';
import {
  type SimpleAlertOptions,
  SimpleAlertOptionsDefaults,
} from '../simple-ui.service';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-simple-alert',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './simple-alert.component.html',
  styleUrl: './simple-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleAlertComponent implements OnInit, OnDestroy {
  options = signal<SimpleAlertOptions>(SimpleAlertOptionsDefaults);
  exitModal = signal<(result?: string) => void>(() => { });
  promptForInput = signal(false);
  inputText = signal('');

  okDisabled = computed(() => {
    return this.promptForInput() && this.inputText().length === 0;
  });

  ngOnInit() {
    if (this.options().defaultInput) {
      this.inputText.set(this.options().defaultInput!);
    }
  }

  // eslint-disable-next-line
  ngOnDestroy(): void {
    // AutoUnsubscribe
  }

  public ok() {
    this.exitModal()(this.promptForInput() ? this.inputText() : 'ok');
  }

  public cancel() {
    this.exitModal()(undefined);
  }
}
